import { create } from 'zustand';
import { QuestionOutput } from '@/api/gql/graphql';
import { Options } from '@/components/Common/Selects/Select.types';
import { DisciplineOutput } from '@/api/gql/graphql';

type QuizFormMode = 'create' | 'update';

type GeneratedQuizStore = {
  selectedGeneratedQuizz: QuestionOutput | null;
  generatedFormMode: QuizFormMode;
  isOpenGeneratedQuizzModal: boolean;
  generatedInitialSelectedOptions: Options | DisciplineOutput | null;
  setSelectedGeneratedQuizz: (quizz: QuestionOutput | null) => void;
  setGeneratedFormMode: (mode: QuizFormMode) => void;
  openGeneratedQuizzModal: () => void;
  setGeneratedInitialSelectedOptions: (
    options: Options | DisciplineOutput | null,
  ) => void;
};

export const useGeneratedQuizStore = create<GeneratedQuizStore>()((set) => ({
  selectedGeneratedQuizz: null,
  generatedFormMode: 'create',
  isOpenGeneratedQuizzModal: false,
  generatedInitialSelectedOptions: null,
  setSelectedGeneratedQuizz: (quizz) => set({ selectedGeneratedQuizz: quizz }),
  setGeneratedFormMode: (mode) => set({ generatedFormMode: mode }),
  openGeneratedQuizzModal: () =>
    set((state) => ({
      isOpenGeneratedQuizzModal: !state.isOpenGeneratedQuizzModal,
    })),
  setGeneratedInitialSelectedOptions: (options) =>
    set({ generatedInitialSelectedOptions: options }),
}));
